import React, { useEffect, useState } from "react";

// import components
import FooterNew from "../components/Footer-New.js";
import NavbarInner from "../components/Navbar-Inner";
import TransactionHistory from "../components/WalletNew/TransactionHistory"
import NavbarInnerSide from "../components/NavbarInnerSide.js";
import Sidebar from "../components/Sidebar.js";

export default function TransactionHistoryPage(props) {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div>
    
     {/* <NavbarInner /> */}
      <NavbarInnerSide toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      <div className="flex w-full relative">
        <Sidebar isOpen={isSidebarOpen} closeSidebar={() => setIsSidebarOpen(false)} />
        <div className="flex-1 w-full overflow-hidden p-4">
              <TransactionHistory />
           </div>
      </div>
      {/* <FooterNew/> */}
      {/* <NavbarFixed /> */}
    </div>
  );
}
